import { motion } from "framer-motion";
import { TiTick } from "react-icons/ti";
import { data } from "./data";
export const FeaturesOfWebApp = () => {
  return (
    <section className="container space-y-14">
      <section className="flex flex-col lg:flex-col space-y-10">
          
             {" "}
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[45px] md:text-5xl font-bold text-dark font-butler text-center "
            >
              Essential Features of a Modern Web App {" "}
            </motion.h2>
           
         <div className="w-full md:w-10/12 mx-auto flex flex-col justify-center md:px-6 xl:px-7 space-y-3 ">
            { data.map((element,i)=>(
<div key={i} className="flex items-start  text-base md:text-lg">
              <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-1">
                <TiTick />
              </span>
              <div>

              <h3 className="text-lg font-bold text-dark inline">
                {element.boldText}:{" "}
              </h3>
                 <p className="text-base leading-[1.625rem] text-dark inline">
               {element.text}
              </p>
              </div>
            </div>
            ) )}
           
        
        </div>
      </section>
    
    </section>
  );
};
